import { render, staticRenderFns } from "./EditLibraryItem.vue?vue&type=template&id=059f85ea&scoped=true&"
import script from "./EditLibraryItem.vue?vue&type=script&lang=js&"
export * from "./EditLibraryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f85ea",
  null
  
)

export default component.exports